import api from "api";
import BlockHeader from "component/BlockHeader/BlockHeader";
import PaginationWrapper from "component/Pagination";
import React, { Fragment, useEffect, useState } from "react";
import { connect } from "react-redux";
import { createBrowserHistory, parsePath } from "history";
import { useLocation, useNavigate, useSearchParams, createSearchParams } from "react-router-dom";
import stateMap from "store/stateMap";
import update from 'immutability-helper';
import Sidebar from "component/Sidebar";
import _ from "lodash";
import Header from "component/Header/Header";
import Footer from "component/Footer/Footer";
import Breadcrumb from "component/Breadcrumb";
import "./index.scss";
import { SkillFinder } from "component/SkillFinder";
import { TalentPoolSlider } from "component/TalentPool";
import LoginBox from "component/LoginBox/LoginBox";
import { PageCredential } from "component/PageCredential";

export default connect(stateMap)((props) => {

    const [interest, setInterests] = useState(false);
    useEffect(() => {
        api('/Interest', 'post', {
            paged               : 1
            ,posts_per_page     : -1
        })
            .then(response => {
                setInterests(response.interest);
            })
    }, []);

    let location                                = useLocation();
    let history                                 = createBrowserHistory();
    
    const [talents, setTalents]         = useState(false);
    const [countTalent, setCountTalent] = useState(false);
    const [dataLoading, setDataLoading]         = useState(false) ;
    const queryString                           = new URLSearchParams(parsePath(window.location.href).search || '');
    const [parameter, setParameter]             = useState({
        paged           : parseInt(queryString.get('paged') || 1)  
        ,posts_per_page : parseInt(queryString.get('posts_per_page')) || 15
        ,interest       : parseInt(queryString.get('interest')) || ''
        ,ageRange       : parseInt(queryString.get('ageRange')) || ''
        ,gender         : queryString.get('gender') || ''
        ,search         : queryString.get('search') || ''
        ,skill          : false
    });


    const changeParams = (e) => {
        e.preventDefault();

        if(dataLoading)
        {
            return;
        }

        let [toUpdateFilter, updatedValue] = e.currentTarget.name.split(':');

        setParameter(
            update(parameter, { $apply : function(params){

                if(params[toUpdateFilter] == updatedValue)
                {
                    params[toUpdateFilter] = '';
                }
                else
                {
                    params[toUpdateFilter] = updatedValue;
                }
    
                params.paged = 1;
    
                return _.assign({}, params);
    
            }})
        );
    }

    const loadTalent = () => {

        if(!props.auth.user)
        {
            return;
        }

        if(dataLoading)
        {
            return;
        }

        var DataToLoad = [
            api('/TalentPool', 'post', _.assign({
                include_user_score : 1
                ,include_bio : 1
            }, parameter), 'Bearer ' + props.auth.token)
        ];

        DataToLoad.push(
            api('/TalentPool', 'post', _.assign({get_total : 1}, parameter), 'Bearer ' + props.auth.token)
        );
        // if(parameter.paged === 1)
        // {
        // }

        setDataLoading(true);

        Promise.all(DataToLoad)
            .then((response) => {
                setDataLoading(false);

                setTalents(response[0].talent);

                history.replace(
                    { search: `?${createSearchParams(parameter)}`}
                );

                setCountTalent( parseInt(response[1].talent) );
                if(parameter.paged === 1)
                {
                }

            })
            .catch((error) => {
                setDataLoading(false);
                
            })
    }
    
    useEffect(loadTalent, [props.auth.user, parameter]);

    return(
        <>
            <Header/>
            <PageCredential title={"Talent"} />
            <div style={{background : '#FAFAFA'}}>
                <div className="container relative" >
                    {
                        !props.auth.user ? 
                        <div className="w-640 mx-auto">
                            <div className="text-center bold text-sm" style={{padding : '12px'}}>
                                Login to see list of available talents
                            </div>
                            <hr />
                            <br />
                            <div className="flex flex-wrap h-center">
                                <LoginBox/>  
                            </div>
                        </div> 
                        : 
                        <div id="talent-archives">
                            <Sidebar>
                                <div className="talents-filters filters-boxes">
                                    <div className="filter-box">
                                        <div className="wrapper">
                                            <div className="filter-body generic-form" style={{paddingRight : '24px'}}>
                                                <input type="text" className="form-control text rounded" defaultValue={parameter.search} placeholder={"Search Talent Name..." } onChange={_.debounce((e) => {

                                                    setParameter(update(parameter, {
                                                        search : {
                                                            $set : e.target.value
                                                        }
                                                    }))
                                                }, 200)} />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="filter-box">
                                        <div className="wrapper">
                                            <span className="filter-title">
                                                Skill
                                            </span>
                                            <div className="filter-body">
                                                <div className="generic-form" style={{paddingRight : '24px'}}>
                                                <SkillFinder
                                                    className="form-control text rounded"
                                                    placeholder="Filter by Skill"
                                                    onTextChange={ (e) => {
                                                        
                                                    }}
                                                    onTextBlur={ e => {
                                                        
                                                    }}
                                                    onPillSelected={skill => {
                                                        setParameter(update(parameter, {
                                                            skill : {
                                                                $set : skill.SkillID
                                                            }
                                                        }))
                                                    }}
                                                />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="filter-box">
                                        <div className="wrapper">
                                            <span className="filter-title">
                                                Gender
                                            </span>
                                            <div className="filter-body">
                                                <ul className="filter-items">
                                                    <li 
                                                        className={`leading-text filter-item ${'male' == parameter.gender && 'active'}`}>
                                                            <a 
                                                                href="#" 
                                                                name={`gender:male`} 
                                                                onClick={changeParams} 
                                                                dangerouslySetInnerHTML={{__html : 'Male' }}/>
                                                    </li>
                                                    <li 
                                                        className={`leading-text filter-item ${'female' == parameter.gender && 'active'}`}>
                                                            <a 
                                                                href="#" 
                                                                name={`gender:female`} 
                                                                onClick={changeParams} 
                                                                dangerouslySetInnerHTML={{__html : 'Female' }}/>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="filter-box">
                                        <div className="wrapper">
                                            <span className="filter-title">
                                                Age
                                            </span>
                                            <div className="filter-body">
                                                <ul className="filter-items">
                                                    <li 
                                                        className={`leading-text filter-item ${'1' == parameter.ageRange && 'active'}`}>
                                                            <a 
                                                                href="#" 
                                                                name={`ageRange:1`} 
                                                                onClick={changeParams} 
                                                                dangerouslySetInnerHTML={{__html : 'Before 20' }}/>
                                                    </li>
                                                    <li 
                                                        className={`leading-text filter-item ${'2' == parameter.ageRange && 'active'}`}>
                                                            <a 
                                                                href="#" 
                                                                name={`ageRange:2`} 
                                                                onClick={changeParams} 
                                                                dangerouslySetInnerHTML={{__html : '20 to 30' }}/>
                                                    </li>
                                                    <li 
                                                        className={`leading-text filter-item ${'3' == parameter.ageRange && 'active'}`}>
                                                            <a 
                                                                href="#" 
                                                                name={`ageRange:3`} 
                                                                onClick={changeParams} 
                                                                dangerouslySetInnerHTML={{__html : 'Over 30' }}/>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="filter-box">
                                        <div className="wrapper">
                                            <span className="filter-title">
                                                Interest
                                            </span>
                                            <div className="filter-body">
                                                <ul className="filter-items interests-list">
                                                    {

                                                        interest !== false && interest.map(field => (
                                                            <li 
                                                                key={field.InterestID}
                                                                className={`leading-text filter-item ${field.InterestID == parameter.interest && 'active'}`}>
                                                                    <a 
                                                                        href="#" 
                                                                        name={`interest:${field.InterestID}`} 
                                                                        onClick={changeParams} 
                                                                        dangerouslySetInnerHTML={{__html : field.InterestName }}/>
                                                            </li>
                                                        ))
                                                    }
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Sidebar>
                            <div className="talent-list-container">

                                <Breadcrumb
                                    items={[
                                        ['/', 'Crowdbees']
                                        ,['Talent']
                                    ]}
                                />
                                <div className="talents-list">
                                    {
                                        talents === false ? <span className="skeleton"></span>:
                                        (
                                            <Fragment>
                                                {
                                                    dataLoading ? <div><span className="skeleton"></span></div> :
                                                    <>
                                                        { 
                                                            <BlockHeader title="Talent" desc={"About "+ countTalent.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".") +" talents"}/>
                                                        }

                                                        <TalentPoolSlider talents={talents}/>

                                                        <PaginationWrapper
                                                            className="mt-4"
                                                            activePage={parameter.paged}
                                                            itemsCountPerPage={parameter.posts_per_page}
                                                            totalItemsCount={countTalent}
                                                            pageRangeDisplayed={5}
                                                            onChange={(pagenumber) => {
                                                                setParameter(update(parameter, { paged : {$set : pagenumber } }))
                                                            }}
                                                        />
                                                    </>
                                                }
                                            </Fragment>
                                        )
                                    }
                                </div>
                            </div>
                        </div>
                    }
                </div>
            </div>
            <Footer/>
        </>
    )
});